import { useState } from "react";
import { TextSize } from "./TextSize.tsx";
import { ThemeToggle } from "./ThemeToggle.tsx";
import { ToggleWord } from "./ToggleWord.tsx";

/**
 * How the page is shown (text size, light or dark), at the end of the bar across the top. On a phone they wait
 * behind "More" on a line of their own, as the play screen's masthead has them, so the bar stays one line.
 */
export function PageSettings() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ToggleWord className="tabs-more" expanded={open} onClick={() => setOpen(!open)}>
        {open ? "Less" : "More"}
      </ToggleWord>
      <span className="tabs-settings" data-open={open}>
        <TextSize />
        <ThemeToggle />
      </span>
    </>
  );
}
